import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { LabelMode } from "src/utils/label-mode.enum";
import { GenerateRandom } from "src/utils/random";

@Component({
    selector: "app-switch",
    templateUrl: "./switch.component.html",
    styleUrls: ["./switch.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SwitchComponent implements OnInit, ControlValueAccessor {
  @Input()
  set isDisabled(value: boolean) {
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() isStar: boolean = false;
  @Input() inputLabel: string;
  @Input() classes: string;
  @Input() labelClasses: string;
  @Input() required: boolean = false;

  @Output() valueChange = new EventEmitter();

  @Input() set labelMode(value: LabelMode) {
    this.mode = value;
  }

  LabelMode = LabelMode;
  mode: LabelMode = LabelMode.INLINE;

  form = new FormControl();

  onChange = (value: string) => {};
  onTouched = (value: string) => {};

  constructor() {}
  ngOnInit(): void {
    this.form.valueChanges.subscribe((value) => {
      this.onChange(value);
      this.valueChange.emit(value);
    });
  }

  writeValue(obj: any): void {
    this.form.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}
}
